import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global smooth-scroll wrapper.
 * Uses Lenis with a subtle easing curve and mobile-friendly settings.
 * Automatically disables on prefers-reduced-motion.
 */
export default function useSmoothScroll() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false, // avoid janky iOS
      touchMultiplier: 1.2,
      wheelMultiplier: 1.0,
    });

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}
